import { Inject, Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FotoService {
  private readonly NOME_FOTO = 'FOTOX';
  private readonly NOME_USER = 'USER';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  storeFoto(foto: any, idServ: string) {
    if (isPlatformBrowser(this.platformId)) {
      //console.log('vou armazenar', this.NOME_FOTO + '-' + mat);
      localStorage.setItem(this.NOME_FOTO + '-' + idServ, foto);
    }
  }
  removeFoto(idServ: string) {
    //console.log('vou apagar', this.NOME_FOTO + '-' + mat);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(this.NOME_FOTO + '-' + idServ);
    }
  }
  getFoto(idServ: string) {
    /*console.log(
      'vou pegar',
      this.NOME_FOTO + '-' + idServ,
      localStorage.getItem(this.NOME_FOTO + '-' + idServ)
    );*/
    return isPlatformBrowser(this.platformId)
      ? localStorage.getItem(this.NOME_FOTO + '-' + idServ)
      : '';
  }
}
